<ng-container *ngIf="upgrading$ | async as upgrading">
  <app-spinner
    *ngIf="upgrading.isUpgrading"
    class="pos-abs bg-white z-index-2 inset-0 radius-4"
    [message]="upgrading.message">
  </app-spinner>
</ng-container>

<ng-container *ngIf="safetiesList$ | async as safeties; else skeleton">
  <div class="fx-row fx-align-center fx-justify-between w-full fx-wrap fx-gap-3">
    <ng-container *ngIf="uiFramework === 'material'; else ionicTitle">
      <lib-block-title
        id="upgrade-safety-title"
        [title]="labels.safetyTitle">
      </lib-block-title>
    </ng-container>
    <ng-template #ionicTitle>
      <ion-title
        id="upgrade-safety-title"
        class="ion-padding body-1 body-1 text-grey-400 pb-0 px-3">
        {{ labels.safetyTitle }}
      </ion-title>
    </ng-template>
    <div
      *ngIf="selectedSafety$ | async as selectedSafety"
      class="text-grey-400 px-3">
      <span class="tw-font-medium">
        {{ labels.currentVersion }} - {{ selectedSafety.country }}, {{ selectedSafety.region }}, {{ selectedSafety.version }}
      </span>
    </div>
  </div>

  <ng-container *ngIf="uiFramework === 'material'; else ionicTable">
    <!-- Desktop Table -->
    <azzurro-table
      id="safety-table"
      [uiFramework]="'material'"
      [columns]="tableColumns"
      [data$]="safeties$"
      [mode]="'client'"
      [filterEnabled]="true"
      [pagination]="true"
      [paginationConfig]="{ pageSizeOptions: [5, 10, 25, 100] }"
      [noResultTemplate]="noSafetyTemplate">
    </azzurro-table>

    <!-- Mobile List -->
    <azzurro-table
      id="safety-list"
      [uiFramework]="'ionic'"
      [columns]="tableColumns"
      [data$]="safeties$"
      [mode]="'client'"
      [filterEnabled]="true"
      [noResultTemplate]="noSafetyTemplate">
    </azzurro-table>
  </ng-container>
  <ng-template #ionicTable>
    <!-- Ionic List -->
    <azzurro-table
      [uiFramework]="'ionic'"
      [columns]="tableColumns"
      [data$]="safeties$"
      [mode]="'client'"
      [filterEnabled]="true"
      [noResultTemplate]="noSafetyTemplate">
    </azzurro-table>
  </ng-template>
</ng-container>

<ng-template #skeleton>
  <ng-container
    *ngIf="uiFramework === 'material'; else ionicSkeleton">
    <div
      class="fx-row fx-align-center fx-justify-between w-full fx-wrap fx-gap-3 mb-2">
      <ion-skeleton-text
        animated
        class="w-40 h-8">
      </ion-skeleton-text>
      <ion-skeleton-text
        animated
        class="w-60 h-6">
      </ion-skeleton-text>
    </div>
    <ion-skeleton-text
      animated
      class="w-full h-10 mb-2">
    </ion-skeleton-text>
    <section
      id="device-table"
      class="tw-w-full overflow-hidden border-1 tw-rounded tw-border-grey-100 fx-col">
      <div
        *ngFor="let _ of [].constructor(5)"
        class="fx-row fx-align-center fx-justify-between fx-gap-3 border-b-1 border-grey-100 p-1">
        <ion-skeleton-text
          animated
          class="w-20 h-6">
        </ion-skeleton-text>
        <ion-skeleton-text
          animated
          class="w-20 h-6">
        </ion-skeleton-text>
        <ion-skeleton-text
          animated
          class="w-20 h-6">
        </ion-skeleton-text>
        <ion-skeleton-text
          animated
          class="w-10 h-6">
        </ion-skeleton-text>
      </div>
    </section>
    <ion-skeleton-text
      animated
      class="w-full h-8 mt-2">
    </ion-skeleton-text>
  </ng-container>
  <ng-template #ionicSkeleton>
    <ion-skeleton-text
      animated
      class="w-9p h-8 mt-2 mx-auto">
    </ion-skeleton-text>
    <ion-toolbar>
      <ion-skeleton-text
        animated
        class="w-8p h-10"
        style="margin: 0 auto;">
      </ion-skeleton-text>
    </ion-toolbar>
    <ion-list
      lines="none"
      id="device-table">
      <ion-item
        *ngFor="let _ of [].constructor(5)">
        <ion-skeleton-text
          animated
          class="w-full h-10"
          style="margin: 0 auto;">
        </ion-skeleton-text>
      </ion-item>
    </ion-list>
  </ng-template>
</ng-template>

<!-- Templates for azzurro-table -->

<!-- No safety template -->
<ng-template #noSafetyTemplate>
  <div class="p-3 text-center text-grey-400 w-full bg-grey-100 border-1 radius-4 border-grey-200">
    {{ labels.noSafety }}
  </div>
</ng-template>

<!-- Version template -->
<ng-template #versionTemplate let-row>
  <span>
    {{ row.version }}
    <span *ngIf="row.selected" class="current-safety-badge ml-1">
      ({{ labels.currentVersion }})
    </span>
  </span>
</ng-template>

<!-- Actions template -->
<ng-template #actionsTemplate let-row>
  <button
    type="button"
    mat-icon-button
    class="action-button"
    [disabled]="disabled || row.selected"
    [class.tw-opacity-50]="disabled || row.selected"
    [matTooltip]="labels.upgrade"
    (click)="chooseSafety(row)">
    <mat-icon
      [class.text-grey-300]="disabled || row.selected"
      [class.text-accent]="!disabled && !row.selected">
      publish
    </mat-icon>
  </button>
</ng-template>